import * as types from '../mutation-types'

export const mutations = {
  [types.RECEIVE_LICENSE_STATUS] (state, { violation }) {
    state.violation = violation
  },
}

const module = HTTP => ({
  state: {
    violation: false,
  },
  mutations,
  actions: {
    async getLicenseStatus ({ commit }) {
      try {
        const response = await HTTP.get('/licensing/status')
        const status = response.data
        if (status.violation) {
          commit(types.RECEIVE_LICENSE_STATUS, { violation: status.violation })
        } else {
          commit(types.RECEIVE_LICENSE_STATUS, { violation: false })
        }
      } catch (e) {
        console.log(e)
      }
    },
  },
})

export default {
  module,
}
